export * from './appointment';
export * from './color';
export * from './message';
export * from './style';
export * from './theme';
export * from './time';
export * from './user';
export const assertContext = (context, hook, provider) => {
    if (!context) {
        throw new Error(`${hook} must be used within the ${provider}`);
    }
    return context;
};
//# sourceMappingURL=index.js.map